import { render, staticRenderFns } from "./CACA-Pre.vue?vue&type=template&id=28434f65&scoped=true"
import script from "./CACA-Pre.vue?vue&type=script&lang=js"
export * from "./CACA-Pre.vue?vue&type=script&lang=js"
import style0 from "./CACA-Pre.vue?vue&type=style&index=0&id=28434f65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28434f65",
  null
  
)

export default component.exports